/**
 * Naming and imagery for the assistant, kept in one place so the drawer title,
 * launcher tooltip, aria-labels and greeting cannot drift apart.
 */

/** Product name for the assistant, shown to users. */
export const ASSISTANT_NAME = 'Sentry';

/**
 * The Gate Check app icon, reused so the assistant reads as part of the same
 * product family. Same asset as the mobile app promo banner.
 */
export const ASSISTANT_ICON_URL = 'https://static.secur.space/icons/gate-check-app-icon.png';
